export default {
  settlement: {
    pay: {
      title: '支付服务',
      channel: '支付渠道',
      method: '结算方法',
      rate: '费率',
      serviceFee: 'Service Fee',
      total: '合计费率',
      trade: '交易费用(日元)',
      cycle: '清算周期',
      tax: '课税',
      select: '选择'
    },
    pci: {
      title: 'PCI DSS符合情况',
      date: 'PCI DSS符合待定年月',
      yes: '有',
      no: '无',
      plan: '待定',
      tip: '如果您有符合PCI DSS标准的证书，请选择“符合”；如果没有，请选择“不符合计划”。'
    },
    card: {
      title: '卡信息保持状况',
      date: '没有无保留计划年月',
      yes: '无保留',
      no: '没有无保留计划',
      tip1: '如果以后不打算在本公司内处理客户的卡号，请选择“非保持化”。',
      tip2: '如果您的系统公司符合PCI DSS标准，并且您已获得证书，请选择“无保留计划”。'

    },
    ic: {
      title: '结算终端IC化实施状况',
      date: '结算终端IC化实施预定年月',
      yes: '有',
      no: '無',
      plan: '待定'
    },
    goods: {
      title: '订购支付终端等',
      goods: '对象商品',
      firstCost: '初期安装费用',
      price: '商品价格',
      count: '数量',
      bond: '保证金',
      totalAmount: '总金额',
      action: '操作'
    },
    questionnaire: {
      title: '信用卡信息安全对策问卷调查',
      // 基本信息部分
      section1: {
        title: '（一）请填写贵加盟店的相关信息。',
        fields: {
          storeName: '1.1. 加盟店名称（公司名称）',
          websiteUrl: '1.2. 运营的网站地址',
          representativeName: '1.3. 代表人姓名',
          responderName: '1.4. 填写人姓名',
          phoneNumber: '1.5. 电话号码',
          email: '1.6. 电子邮箱'
        },

        placeholders: {
          storeName: '请输入公司名称',
          websiteUrl: 'https://example.com',
          representativeName: '请输入代表人姓名',
          responderName: '请输入填写人姓名',
          phoneNumber: '010-1234-5678',
          email: 'email@example.com'
        }


      },
      // 销售方式部分
      section2: {
        title: '（二）接下来，请回答贵加盟店的销售方式等情况。',
        fields: {
          acceptCreditCard: {
            label: '2.1. 贵加盟店是否申请信用卡支付？',
            options: {
              online: { label: '是', value: true },
              offline: { label: '否', value: false }
            }
          },
          paymentType: {
            label: '2.2. 线上支付、线下支付',
            options: {
              online: { label: '线上', value: true },
              offline: { label: '线下', value: false }
            }
          },
          salesMethod: {
            label: '2.3. 销售方式是哪一种？',
            options: [
              { label: '门店销售（面对面销售）', value: 'DOORSALE' },
              { label: '电话或传真销售', value: 'PHONESALE' },
              { label: '通过互联网销售（自有网站）', value: 'WEBSALE' },
              { label: 'APP等销售', value: 'APPSALE' },
              { label: '其他（自由填写）', value: 'OTHERSALE' }
            ],
          },
          otherSalesMethod: {
            label: '其他销售方式',
            placeholder: '请输入其他销售方式'
          }
        }
      },

      // 系统对策部分
      
      section3: {
        title: '（三）卡信息管理现状（系统对策）',
        note: '※请告知在第3～4项回答中标记为"否"的事项，计划的改进时间。',
         measures: {
          tls: '是否使用TLS/HTTP加密？',
          phone_security: 'PC/手机的安全软件是否为最新？',
          use_pay_tool: '是否使用支付服务商提供的最新工具？',
          import_emv3d: '是否导入EMV3-D Secure？',
          set_strong_pwd: '管理后台是否设置强密码和MFA？',
          access_permission: '系统访问权限是否仅限最少人员？',
          check_access_log: '是否定期检查访问日志？'
        },
      
        
       
        improvementLabel: '预计改进时间'
      },

      // 非系统对策部分
      section4: {
        title: '（四）卡信息管理现状（非系统对策）',
        note: '※请告知在第3～4项回答中标记为"否"的事项，计划的改进时间。',
        nonSystemMeasures: {
          set_employee_rule: '是否已制定员工规章并进行教育？',
          scty_personal_info: '是否安全管理含个人信息的纸质文件？',
          set_customer_info: '是否明确并教育客户信息可提供范围？',
          set_card_info_approval: '是否设立并实施卡信息审批流程？'
        },
       
        improvementLabel: '预计改进时间'
      },

      // 其他部分
      section5: {
        title: '（五）其他（自由填写）',
        placeholder: '如有其他意见或要求，请在此填写。'
      },

      table: {
        header1: '内容',
        header2: '回答栏',
        header3: '预计改进时间'
      },

       tip: {
        add: '您已选择信用卡支付方式，需要填写信用卡信息安全对策问卷。',
        view: '已提交信用卡信息安全对策问卷，'
      },
      addButton: '添加问卷',
      viewButton: '查看问卷',
      submitSuccessed: '问卷提交成功',
      updateSuccessed: '问卷更新成功',
      qatips:'请先创建问卷再提交',
      
      confirmButton: '确认提交内容',
      yes: '是',
      no: '否',
      submitSuccess: {
        title: '提交成功',
        thankYou: '衷心感谢您的合作。',

      }
    }
  }
}
